// Object-capture GPU pipeline stages (backend/gpuworker/gpu-object-splat.sh status.json) +
// friendly progress copy. "booting" (box not yet running the script) may appear before
// "starting" — it is shown as pre-pipeline copy rather than a pipeline step.

export const OBJECT_STAGES = [
  "starting",
  "ingest",
  "sfm",
  "masking",
  "training",
  "exporting",
  "postprocessing",
  "uploading",
  "meshing",
] as const;

export const OBJECT_STAGE_COPY: Record<string, string> = {
  queued: "Queued — waiting for a GPU…", // status fallback when the box hasn't reported a stage yet
  booting: "Starting up a GPU…",
  starting: "Preparing the job…",
  ingest: "Extracting frames from your capture…",
  sfm: "Solving camera path…",
  masking: "Removing background…",
  training: "Training gaussian splat…",
  exporting: "Exporting the model…",
  postprocessing: "Polishing the splat…",
  uploading: "Uploading results…",
  meshing: "Building a mesh…",
};

export function objectStageCopy(stage?: string | null): string {
  return (stage && OBJECT_STAGE_COPY[stage]) || "Processing…";
}
